import styled from "styled-components";
import { lineChart } from "../../assets";
import { device } from "../../style";
import { Typography } from "../Typography/Typography";

type EarnedBarProps = {
  value: string;
  label: string;
};

const EarnedBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: calc(100% - 22px);
  gap: 15px;
  border-radius: 0px 0px 12px 12px;
  background: #08a98a33;
  padding: 6px 15px 6px 6px;

  @media ${device.tablet} {
    border-radius: 0 12px 12px 0;
    padding-top: 7.78px;
    padding-bottom: 5.78px;
    min-height: 30.28px;
  }

  @media ${device.laptop} {
    width: 100%;
    white-space: nowrap;
    min-width: 255px;
  }
`;

const LineChartImg = styled.img`
  width: 21px;
  height: 16px;
`;

const RightSideWrapper = styled.div`
  display: flex;
  gap: 4px;
  justify-content: flex-end;
  align-items: center;
`;

const Value = styled.p`
  color: #08a98a;
  font-family: Ingra;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 93.5%; /* 11.22px */
`;

const Label = styled.p`
  color: #26a677;
  font-family: Ingra;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 93.5%;
  text-transform: uppercase;
`;

export const EarnedBar = ({ value, label }: EarnedBarProps) => (
  <EarnedBarWrapper>
    <LineChartImg src={lineChart} alt="chart line" />
    <RightSideWrapper>
      <Value>{value}</Value>
      <Label>{label}</Label>
      <Typography.IngraSmallLabel>
        EARNED IN THE LAST DAY
      </Typography.IngraSmallLabel>
    </RightSideWrapper>
  </EarnedBarWrapper>
);
